'use strict'

Modernizr = require '../vendor_modules/modernizr'

# map new 3.x touch test to the 2.x touch test name and class
if Modernizr.touchevents isnt undefined
  # https://github.com/videojs/video.js/issues/3306 - hack for win10 + chrome touchscreen machines
  Modernizr.touchevents = Modernizr.touchevents.valueOf() or !!window.navigator.maxTouchPoints
  Modernizr.touch = Modernizr.touchevents
  document.documentElement.className += if Modernizr.touchevents then ' touch' else ' no-touch'

# patched test to work within an iframe
Modernizr.addTest 'csspseudoanimations', ->
  result = false

  return result unless ( Modernizr.cssanimations and window.getComputedStyle )

  styles = [
    '@', Modernizr._prefixes.join('keyframes csspseudoanimations { from { font-size: 10px; } }@').replace(/@$/, ''),
    '#modernizr:before { content:" "; font-size:5px;',
    Modernizr._prefixes.join('animation:csspseudoanimations 1ms infinite;'),
    '}'
  ].join('')

  Modernizr.testStyles styles, (elem) ->
    style = window.getComputedStyle(elem, ':before')
    if style isnt null
      result = style.getPropertyValue('font-size') is '10px'
  result



// WEBPACK FOOTER //
// ./core/frontend/groupon_modules/modernizr-hacks.coffee